import styled from 'styled-components';

export const DivTitle = styled.h1`
  color: ${(props) => props.theme.color1};
`;
